<template>
  <select2
    @select="onSelect"
    @change="onChange"
    :options="options"
    :settings="setting"
    :placeholder="placeholder || ($t('Search member by phone or name') + '...')"
  />
</template>

<script>
import { AUTH } from '@/services/endpoint/_constants';
import Select2 from 'vue3-select2-component';
import signature from '@/services/signature';

/**
 * Reusable member search (ajax → /v1/customers?search=) ผ่าน signed axios
 * emit:
 *   @selected = { id, fullname, telephone }  เมื่อเลือก member
 *   @cleared  = เมื่อกดล้าง (allowClear)
 */
export default {
  name: 'MemberSelect',
  components: { Select2 },
  props: {
    dropdownParent: { type: String, default: '' },
    placeholder: { type: String, default: '' },
  },
  emits: ['selected', 'cleared'],
  data() {
    const vm = this;

    return {
      options: [],
      setting: {
        dropdownParent: this.dropdownParent || undefined,
        allowClear: true,
        minimumInputLength: 1,
        language: {
          loadingMore: () => '<i class="fa-solid fa-spinner fa-spin" />',
          searching: () => vm.$t('Searching') + '...',
          inputTooShort: () => vm.$t('Type to search') + '...',
          noResults: () => vm.$t('No members found'),
        },
        ajax: {
          beforeSend: (request) => request.setRequestHeader('Authorization', 'Bearer ' + AUTH.TOKEN),
          url: AUTH.URL + '/v1/customers',
          data: function (params) {
            var query = { search: params.term, page: params.page || 1, limit: 10 };
            return signature($.param(query)).substring(1);
          },
          processResults: function (data) {
            var option = (data.data || []).map(function (c) {
              return {
                id: c.id,
                text: (c.fullname || '-') + (c.telephone1 ? ' · ' + c.telephone1 : '') + (c.member_code ? ' · ' + c.member_code : ''),
                fullname: c.fullname,
                telephone: c.telephone1,
              };
            });

            return {
              results: option,
              pagination: { more: (data.meta.current_page * 10) < data.meta.total },
            };
          },
        },
      },
    };
  },
  methods: {
    onSelect(e) {
      this.$emit('selected', { id: e.id, fullname: e.fullname, telephone: e.telephone });
    },
    onChange(val) {
      if (!val) this.$emit('cleared');
    },
  },
};
</script>
